'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function scrollToTop() {
    window.scrollTo(0, 0);
}
function scrollTo(config) {
    var elem;
    if (config.element) {
        elem = config.element;
    }
    else {
        elem = document.getElementById(config.id);
    }
    if (!elem) {
        return;
    }
    setTimeout(function () {
        elem.scrollIntoView({
            behavior: 'smooth',
            block: config.position,
        });
    }, config.delay || 0);
}

exports.default = scrollTo;
exports.scrollToTop = scrollToTop;
//# sourceMappingURL=scroll_to.js.map
